<template>
  <div class="info_warp">

     <div class="back">
      <img src="@/static/back1.png"
           @click="back"
           alt="">
      
    </div>
    <div style=" overflow: scroll;" class="main">
      <!-- question -->
       <div class="content">
      <div class="tiwen" style=" border-bottom: 1rem solid #e5e5e5;border-radius: 20rem 20rem 0rem 0rem;">
        <div class="head">
          <div>
            <img src="@/static/dayi/tx.png"
                 alt="" />
                 <div style="display: flex;flex-direction: column;">
            <div>{{ info.discuss_parent.discuss_title || '' }}</div>
            <div class="subject"> {{ info.discuss_parent.board_name || '' }}</div>
            </div>
                   
          </div>
           
        </div>
        <div class="content">
          <div class='left'>
            <div>
              {{ info.discuss_parent.discuss_content }}
            </div>

            <div class="images">
              <!-- <img :src="item"
                 v-for="(item,index) in info.discuss_parent.discuss_image"
                 :key="index"
                 alt=""> -->
              <div v-for="(item, index) in info.discuss_parent.discuss_image"
                   :key="index">
                <a-image width="120rem"
                         height="120rem"
                         :src="item"
                         :preview-src-list="info.discuss_parent.discuss_image">
                </a-image>
              </div>
            </div>

          </div>
          <div style="display: flex;justify-content: space-between;width: 100%">
             <div class="right">
            {{ info.discuss_parent.discuss_time }}
          </div>
          <div class="right">
            <img src="@/static/dayi/icon-未点赞@2x.png"
                 @click="dianzan"
                 v-if="show"
                 alt="" />
            <img src="@/static/dayi/icon-已点赞@2x.png"
                 v-else
                 alt="" />
            <span>
              {{ info.discuss_parent.discuss_upvote_times }}
            </span>
              <img src="@/static/dayi/信息.png"
                 style="margin-left:25rem"
                 alt="">
            {{info.discuss_parent.discuss_re_times}}
          </div>
          
        </div>
        </div>

        <!-- associated question -->
        <div class="associated_question"
             v-if="info.question_data.question_content">
          <div class="header">
            <div class="button"
                 @click="isShowAssociatedQuestion = !isShowAssociatedQuestion">
              <div class="button-item"
                   v-show="isShowAssociatedQuestion">
                <div>查看题目</div>
                <img src="@/static/dayi/pull-down.png"
                     alt="" />
              </div>
              <div class="button-item"
                   v-show="!isShowAssociatedQuestion">
                <div>隐藏题目</div>
                <img src="@/static/dayi/pull-up.png"
                     alt="" />
              </div>
            </div>
          </div>
          <!-- question body -->
          <div class="body"
               v-show="!isShowAssociatedQuestion">
            <div class="title">题目内容</div>
            <div class="content border-radius"
                 v-html="info.question_data.question_content"></div>
            <div class="title">题目答案</div>
            <div class="content border-radius"
                 v-html="info.question_data.question_answer"></div>
            <div class="title">题目解析</div>
            <div class="content "
                 v-html="info.question_data.question_explain"></div>
          </div>
        </div>
        
      </div>
      <div class="textarea">
         <div style="display: flex;gap: 20rem;">  <div> <img src="@/static/dayi/tx.png"
                style="width:60rem;height:60rem"
                     alt="" /></div>
                     <div style="width: 100%;">
        <a-textarea placeholder="发布你的回复"
                             style="width:100%"
                            v-model:value="form.discuss_content"
                            :rows="textRow" />
      </div>
        </div>
      <div style="display: flex;justify-content: space-between;margin-top: 20rem;">
        <div style="margin-left: 80rem;"  >
           <myImg ref='imgRef' v-show="isShow"/>
          <img src="@/static/dayi/pic.png" style="width: 20rem;height: 20rem;"
          @click="uploadimg"
                 alt="">
          </div>
    
      <div class="btn" @click="topost">评论</div>  
      </div>
       </div>
       <div class="common"
           v-if="info.volist_children.length">
        <div class="huida"
        :class="{ last: index === info.volist_children.length - 1 }"
             v-for="(item, index) in info.volist_children"
             :key="index">
          <div v-if="item.review_status == 1">
            <div class="head">
              <div style="color: #2196F3;font-weight: 400;font-size: 16rem;">
                <img src="@/static/dayi/tx.png"
                style="width:40rem;height:40rem"
                     alt="" />
                {{ item.user_id || '' }}
              </div>
               
            </div>
            <div class="content">
              <div class="left">
                <div v-html="item.discuss_content">
                </div>

                <div class="images">
                  <div v-for="(item, index) in item.discuss_image"
                       :key="index">
                    <a-image width="120rem"
                             height="120rem"
                             :src="item">
                    </a-image>
                  </div>
                </div>
                          <div style="display: flex;justify-content: space-between;width: 100%">

                <div class="right">
                {{ item.discuss_time }}
              </div>
                <div class="right">
                  <img src="@/static/dayi/icon-未点赞@2x.png"
                       @click="dianzanChild(item, index)"
                       v-if="item.show"
                       alt="" />
                  <img src="@/static/dayi/icon-已点赞@2x.png"
                       v-else
                       alt="" />
                  <span>
                    {{ item.discuss_upvote_times }}
                  </span>
                </div>
              </div>
                </div>
            </div>
          </div>
          <div v-else>
            <div class="head">
              <div>
                <img src="@/static/dayi/toux.jpg"
                     alt="" />
                {{ item.user_id || '' }}
              </div>
              <div>
                {{ item.review_time }}
              </div>
            </div>

            <div class="reject_warp">
              <div class="reject_content">
                未通过原因:{{item.reason}}
              </div>
              <div class="reject_btn">
                审核不通过
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
      <div class="tiwen"
           style="margin-top:20rem"
           v-if="info.discuss_parent.review_status === -1">
        <div class="head">
          <div>
            <img src="@/static/dayi/toux.jpg"
                 alt="" />
            {{ info.discuss_parent.discuss_title || '' }}
          </div>
          <div>
            {{ info.discuss_parent.review_time }}
          </div>
        </div>

        <div class="reject_warp">
          <div class="reject_content">
            未通过原因:{{info.discuss_parent.reason}}
          </div>
          <div class="reject_btn">
            审核不通过
          </div>
        </div>
      </div>

      
    </div>
    <!-- v-if="info.discuss_parent.review_status !== -1" -->

    <ReplyForm ref="HuifuFormRef"
               title='回复'
               bodyHeight='520rem'
               :textRow='8'
               @submit="submit"
               @cancel='cancel' />
  </div>
</template>

<script setup>
import ReplyForm from './form.vue'
import { message, Upload } from 'ant-design-vue'
import { useRoute,useRouter } from 'vue-router'
// import { instance } from '@/utils/http.js'
import { addHeader as globalAddHeader } from '@/init/index.js'
import { getPostInfo, addUpvote, replyPost } from '@/api/post.js'
import { getCurrentInstance, onActivated, onDeactivated, onMounted } from 'vue'
import { ref } from 'vue'
import myImg from '@/views/components/uploadImage/image.vue' //上传图片组件
import TopCard from '@/views/components/top_card/index.vue'
//const { ctx } = getCurrentInstance()
let images = ref([])
let imgRef = ref()
let route = useRoute()
let router = useRouter()
let info = ref({
  discuss_parent: {
    discuss_title: '',
  },
  question_data: {
    question_content: ''
  },
  volist_children: []
})
let form = ref({})
let show = ref(true)
let isShow = ref(false)
let isShowAssociatedQuestion = ref(true)
let HuifuFormRef = ref()

let back = () => {
  router.go(-1)
}

const getTieziInfo = async () => {
  let params = JSON.parse(route.query.form)
  form.value = params
  const { data } = await getPostInfo(params)
  data.discuss_parent.discuss_image = data.discuss_parent.discuss_image
    ? JSON.parse(data.discuss_parent.discuss_image)
    : [];
  data.volist_children = data.volist_children.map(item => {
    item.show = true;
    return item;
  });

  data.volist_children.map(item => {
    item.discuss_image = JSON.parse(item.discuss_image);
    return;
  });
  info.value = data;

}
const addHeader = globalAddHeader
//上传图片
const uploadImage = async () => {
  const { data } = await uploadImageAuto(20, "image/*")
  images.value.push(addHeader(data.dir))
  message.success('上传成功')
  // let userId = JSON.parse(window.localStorage.getItem('userInfo')).user_id
  // window.injectedObject.imageClick(userId, 0)
}
const delImage = (item, index) => {
  images.value.splice(index, 1)
}
const uploadimg = (e) => {
  isShow.value = true
  
}
const topost = () => {
  let form1 = {
    discuss_parent_id: form.value.discuss_id,
    discuss_image: imgRef.value.images.join(',')||'',
    discuss_content: form.value.discuss_content
  };
 console.log('form1', form1,images.value)
  HuifuFormRef.value.form1 = form1;
  submit()
  // HuifuFormRef.value.dialogVisible = true;
}
const dianzan = async () => {
  const { data } = addUpvote({
    discuss_id: info.value.discuss_parent.discuss_id
  }).then(() => {
    message.success('点赞成功');
    info.value.discuss_parent.discuss_upvote_times += 1;
    show.value = false;
    // ctx.$forceUpdate()
  });
}
const dianzanChild = async (item, index) => {
  const { data } = await addUpvote({
    discuss_id: item.discuss_id
  })
  message.success('点赞成功');
  info.value.volist_children[index].discuss_upvote_times += 1;
  info.value.volist_children[index].show = false;

}
const huifu = () => {
  let form1 = {
    discuss_parent_id: form.value.discuss_id,
    discuss_image: [],
    discuss_content: ''
  };
  HuifuFormRef.value.images = [];
  HuifuFormRef.value.form = form1;
  HuifuFormRef.value.dialogVisible = true;
}

//发帖弹窗》提交
const submit = async () => {
  const { data } = replyPost(
    HuifuFormRef.value.form1
  ).then(res => {
    message.success('回复成功')
    cancel()
    getTieziInfo()
  })
}
//发帖弹窗》取消
const cancel = () => {
  HuifuFormRef.value.dialogVisible = false
  imgRef.value.images = []
  isShow.value = false
}

onMounted(() => getTieziInfo())
</script>

<style lang="scss" scoped>

:deep textarea.ant-input{
  border-radius: 16rem;
background: var(--light-f-5-f-5-f-5, #F5F5F5);
height: 60rem;
// padding: 16rem;
color: var(--light-666666, #666);
font-size: 24rem;
}
:deep .ant-image{
  img{
     width: 90rem;
  height: 90rem;
  }
 
}
//抽出公共部分
.main{
  width: 1840rem;
height: 935rem;
border-radius: 20rem 20rem 0 0;
border-top: 2rem solid #FFF;
border-right: 2rem solid #FFF;
border-left: 2rem solid #FFF;
background: rgba(233, 241, 252, 0.90);
margin-left:40rem;

margin-top: 24rem;
}

.content{
  display: flex;
padding: 30rem 40rem;
flex-direction: column;
justify-content: flex-end;
align-items: flex-start;
align-self: stretch;display: flex;
 
flex-direction: column;
justify-content: flex-end;
align-items: flex-start;
align-self: stretch;
width:1660rem
}
.tiwen {
  // box-shadow: 0rem 1rem 10rem 2rem rgba(226, 223, 223, 0.4);
  
  background: white;
  padding: 26rem 40rem;
  .head {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    // border-bottom: 1rem solid #e5e5e5;
    // padding-bottom: 25rem;
    align-items: center;
    .subject {
      display: flex;
// width: 60rem;
// height: 20rem;
// width: 65rem;
padding: 4rem 4rem 4rem 0rem;
color: #FFF !important;
 max-width: 74rem;
font-size: 12rem !important;
font-style: normal;
font-weight: 400;
line-height: 20rem; /* 166.667% */
justify-content: center;
align-items: center;
gap: 10rem;
border-radius: 6rem;
background: #F67171;
    }
    div {
      &:nth-child(1) {
        font-size: 24rem;
        font-weight: bold;
        color: #333333;
        display: flex;
        align-items: center;
        text-indent: 5rem;
        img {
          width: 88rem;
          height: 88rem;
          margin-right: 20rem;
        }
      }
      &:nth-child(2) {
        font-size: 20rem;
        font-weight: 500;
        color: #999999;
      }
    }
  }
  .content {
    margin: 0 auto;
    // margin-top: 19rem;
    font-size: 16rem;
    font-weight: 400;
    color: #333333;
    position: relative;
    .left {
      // width: calc(100% - 140rem);
      // padding: 0 20rem;
      width: 100%;
    }

    .images {
      position: relative;
      // margin-top: 20rem;
      div {
        margin-right: 20rem;
        display: inline-block;
      }
      img {
        width: 120rem;
        height: 120rem;
      }
    }
    .right {
      display: flex;
      align-items: center;
   
     color: var(--light-999999, #999);
 
font-size: 14rem;
font-style: normal;
font-weight: 400;
line-height: 36rem; /* 150% */
      img {
        width: 18rem;
        height: 18rem;
        margin-right: 20rem;
        cursor: pointer;
      }
    }
  }
}
.info_warp {
  width: 100vw;
  height: 100vh; 
 
  overflow-x: hidden;
  background-image: url("../../../static/allBackg/线上答疑.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .back {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30rem;
  padding: 0 40rem;
  img {
    width: 60rem;
    height: 60rem;
    cursor: pointer;
  }
  div {
    background-color: #3e8ef3;
    border-radius: 35rem;
    font-size: 32rem;
    font-weight: 700;
    padding: 6rem 43rem;
    background: #1372e9;
    color: white;
    cursor: pointer;
  }
}
  .tiwen {
    @extend .tiwen;
    // margin-bottom: 30rem;
    .associated_question {
      padding: 17rem 20rem 0 20rem;
      .header {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .button {
          padding: 8rem;
          display: inline-block;
          font-weight: bold;
          font-size: 24rem;
          color: #3f9eff;
          cursor: pointer;
          .button-item {
            display: flex;
            align-items: center;
            img {
              width: 24rem;
              height: 16rem;
              margin-left: 16rem;
              margin-top: 6rem;
            }
            div {
              margin-right: 5rem;
            }
          }
        }
      }
      .body {
        .title {
          position: relative;
          margin: 10rem 7rem;
          font-weight: bold;
          font-size: 24rem;
        }
        // 左边框
        .title::before {
          content: "";
          position: absolute;
          display: inline-block;
          top: 9rem;
          left: -24rem;
          width: 5rem;
          height: 22rem;
          border-radius: 5rem;
          background-color: #2196f3;
        }
        .content {
          margin: 10rem 7rem;
          padding: 7rem;
          line-height: 1.25em;
        }
        .border-radius {
          border-bottom: 1rem solid #e9e9e9;
        }
      }
    }
  }
  :deep .add_img {
  width: 90rem;
  height: 90rem;
  font-weight: 500;
  background: #f6f6f6;
  border-radius: var(--Radius-XS, 8rem);
  text-align: center;
  color: #2196f3;
  border: 1rem dashed transparent;
  cursor: pointer;
  &:hover {
    border: 1rem dashed #2196f3;
    overflow: hidden;
  }
   img {
     width: 90rem;
  height: 90rem;
  }
}
  .textarea{
    width:  1741rem;
    display: flex;
    flex-direction: column;
     
        background: white;
    padding: 26rem 40rem;
    .btn{
      display: flex;
width: 125rem;
height: 50rem;
color: var(--light-ffffff, #FFF);
text-align: center;
 
font-size: 24rem;
font-style: normal;
font-weight: 400;
line-height: 36rem; /* 150% */
justify-content: center;
align-items: center;
gap: 8rem;
flex-shrink: 0;
border-radius: 10rem;
border: 1rem solid var(--30-d-0-f-5, #30D0F5);
background: linear-gradient(104deg, #40CCFF 11.83%, #2196F3 100.74%);
    }
  }
  .common {
    // box-shadow: 0rem 1rem 5rem 1rem rgba(226, 223, 223, 0.4);
    // margin-top: 20rem;
      .huida.last {
border-radius: 0rem 0rem 20rem 20rem;
      }
    .huida {
       padding: 0rem 40rem ;
     .content{
      margin: 0 26rem 0rem 26rem;
      padding-top: 0rem;
      padding-bottom: 0rem;
      width: 1609rem;
      
     }
      @extend .tiwen;
    }
  }
  //回复按钮
  .fixed_btn {
    position: absolute;
    width: 140rem;
    height: 54rem;
    background: #2196f3;
    border-radius: 35rem;
    margin-right: 45rem;
    right: 0rem;
    top: 23rem;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    line-height: 54rem;
    font-size: 24rem;
    cursor: pointer;
  }
}
.reject_warp {
  display: flex;
  height: 108rem;
  .reject_content {
    flex: 1;
    font-weight: bold;
    font-size: 16rem;
    text-indent: 20rem;
    margin-top: 15rem;
  }
  .reject_btn {
    width: 115rem;
    margin-right: 20rem;
    margin-top: 15rem;
    border-radius: 18rem;
    height: 35rem;
    background: #fedddd;
    font-weight: bold;
    color: #ff664e;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
